// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { getDoctors } from "../api/doctors.api";
// import { getAllCategories } from "../api/catalog.api";
// import Header from "../Components/Header";
// import Footer from "../Components/Footer";
// import DoctorCard from "../Components/DoctorCard";
// import EmptyState from "../Components/States/EmptyState";
// import LoadingState from "../Components/States/LoadingState";
// import OfflineState from "../Components/States/OfflineState";
// import { isNetworkError } from "../utils/network";
// import { FaSearch } from "react-icons/fa";
// import {
//   PAGE_CONSULTATION_TYPE,
//   toApiType,
//   fromApiType,
//   mapToDoctorCard,
//   unwrapList,
//   doctorMatchesSpecialty,
//   doctorMatchesSearch,
// } from "../utils/consultation";

// // ponytail: derive specialty chips from doctor list when /staff/getallcategory fails
// const categoriesFromDoctors = (doctors) => {
//   const names = new Set();
//   for (const d of doctors) {
//     if (d.specialization) names.add(d.specialization);
//     for (const c of d.categories || []) {
//       const n = typeof c === "string" ? c : c?.name;
//       if (n) names.add(n);
//     }
//   }
//   return [...names].sort().map((name) => ({ name }));
// };

// const DoctorListPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [rawDoctors, setRawDoctors] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [networkError, setNetworkError] = useState(false);
//   const [consultationType, setConsultationType] = useState(() => {
//     const passed = location.state?.consultationType;
//     if (passed === "Offline" || passed === "Online") return fromApiType(passed);
//     return PAGE_CONSULTATION_TYPE.video;
//   });
//   const [searchTerm, setSearchTerm] = useState("");
//   const [specialtyFilter, setSpecialtyFilter] = useState("");

//   useEffect(() => {
//     let cancelled = false;
//     const load = async () => {
//       try {
//         setNetworkError(false);
//         const catRes = await getAllCategories().catch(() => ({ data: [] }));
//         const cats = unwrapList(catRes.data);
//         let list = [];
//         try {
//           list = unwrapList((await getDoctors(toApiType(consultationType))).data);
//         } catch {
//           list = [];
//         }
//         if (!cancelled) {
//           const finalCats = cats.length ? cats : categoriesFromDoctors(list);
//           setRawDoctors(list);
//           setCategories(finalCats);
//           setSpecialtyFilter((current) => current || finalCats[0]?.name || "");
//         }
//       } catch (err) {
//         if (!cancelled && isNetworkError(err)) setNetworkError(true);
//         else console.error("Error fetching doctors:", err);
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     };
//     load();
//     return () => { cancelled = true; };
//   }, [consultationType]);

//   const apiType = toApiType(consultationType);

//   const doctorsList = useMemo(
//     () => rawDoctors.map((d) => mapToDoctorCard(d, apiType)),
//     [rawDoctors, apiType]
//   );

//   const visibleDoctors = useMemo(() => {
//     const q = searchTerm.trim();
//     return doctorsList.filter((card) => {
//       const raw = card._raw;
//       if (!doctorMatchesSpecialty(raw, specialtyFilter)) return false;
//       return doctorMatchesSearch(raw, q);
//     });
//   }, [doctorsList, specialtyFilter, searchTerm]);

//   const handleBook = (doctor) => {
//     navigate("/consultations/schedule", {
//       state: { doctor, consultationType: apiType },
//     });
//   };

//   return (
//     <div className="bg-background min-h-screen flex flex-col">
//       <Header />
//       <div className="flex flex-col min-h-screen pb-16 lg:pb-0 flex-1">
//         <main className="flex-1 max-w-7xl mx-auto w-full px-3 sm:px-6 py-4 sm:py-8">
//           <header className="mb-6 space-y-4">
//             <h1 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var lg:hidden">
//               Doctor Consultation
//             </h1>

//             <div className="flex flex-col sm:flex-row lg:items-center gap-3 lg:gap-4">
//               <div className="inline-flex self-start bg-surface-low rounded-full p-1 border border-surface-container shrink-0">
//                 {[
//                   { label: "Video Consult", value: PAGE_CONSULTATION_TYPE.video },
//                   { label: "In-Person", value: PAGE_CONSULTATION_TYPE.inPerson },
//                 ].map((tab) => (
//                   <button
//                     key={tab.value}
//                     type="button"
//                     onClick={() => setConsultationType(tab.value)}
//                     className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition ${
//                       consultationType === tab.value
//                         ? "bg-primary-fixed text-on-primary-fixed-var"
//                         : "text-on-surface-variant hover:text-on-primary-fixed-var"
//                     }`}
//                   >
//                     {tab.label}
//                   </button>
//                 ))}
//               </div>

//               <h1 className="hidden lg:block flex-1 text-3xl font-bold text-on-primary-fixed-var text-center">
//                 Doctor Consultation
//               </h1>

//               <div className="relative w-full lg:w-80 shrink-0">
//                 <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant" />
//                 <input
//                   type="text"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   placeholder="Search by name, specialty, or condition..."
//                   className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-surface-container bg-surface-lowest text-sm focus:outline-none focus:ring-2 focus:ring-primary"
//                 />
//               </div>
//             </div>
//           </header>

//           <div className="mb-6 -mx-3 sm:mx-0">
//             <p className="text-sm font-medium text-on-primary-fixed-var mb-2 px-3 sm:px-0">
//               Popular Specialties:
//             </p>
//             <div className="flex gap-2 overflow-x-auto px-3 sm:px-0 pb-1">
//               {categories.slice(0, 8).map((cat) => {
//                 const selected = specialtyFilter === cat.name;
//                 return (
//                   <button
//                     key={cat.name}
//                     type="button"
//                     onClick={() => setSpecialtyFilter(cat.name)}
//                     className={`shrink-0 whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-medium border transition ${
//                       selected
//                         ? "bg-primary text-white border-primary"
//                         : "bg-surface-lowest text-primary border-primary hover:bg-primary-fixed/40"
//                     }`}
//                   >
//                     {cat.name}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {networkError ? (
//             <OfflineState onRetry={() => window.location.reload()} />
//           ) : loading ? (
//             <LoadingState branded message="Loading doctors…" className="py-16" />
//           ) : visibleDoctors.length === 0 ? (
//             <EmptyState
//               title="No doctors found yet."
//               description={`No doctors are available for ${consultationType === PAGE_CONSULTATION_TYPE.video ? "video" : "in-person"} consultation right now. Try another specialty or consultation type.`}
//             />
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
//               {visibleDoctors.map((doctor) => (
//                 <DoctorCard
//                   key={doctor.id || doctor.name}
//                   doctor={doctor}
//                   consultationType={consultationType}
//                   onBookConsult={handleBook}
//                 />
//               ))}
//             </div>
//           )}
//         </main>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default DoctorListPage;



import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDoctors } from "../api/doctors.api";
import { getAllCategories } from "../api/catalog.api";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import DoctorCard from "../Components/DoctorCard";
import EmptyState from "../Components/States/EmptyState";
import LoadingState from "../Components/States/LoadingState";
import OfflineState from "../Components/States/OfflineState";
import { isNetworkError } from "../utils/network";
import { FaSearch } from "react-icons/fa";
import {
  PAGE_CONSULTATION_TYPE,
  toApiType,
  fromApiType,
  mapToDoctorCard,
  unwrapList,
  doctorMatchesSpecialty,
  doctorMatchesSearch,
} from "../utils/consultation";

// ponytail: derive specialty chips from doctor list when /staff/getallcategory fails
const categoriesFromDoctors = (doctors) => {
  const names = new Set();
  for (const d of doctors) {
    if (d.specialization) names.add(d.specialization);
    for (const c of d.categories || []) {
      const n = typeof c === "string" ? c : c?.name;
      if (n) names.add(n);
    }
  }
  return [...names].sort().map((name) => ({ name }));
};

const DoctorListPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rawDoctors, setRawDoctors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [networkError, setNetworkError] = useState(false);
  const [consultationType, setConsultationType] = useState(() => {
    const passed = location.state?.consultationType;
    if (passed === "Offline" || passed === "Online") return fromApiType(passed);
    return PAGE_CONSULTATION_TYPE.video;
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [specialtyFilter, setSpecialtyFilter] = useState("");


  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setNetworkError(false);

      try {
        let cats = [];

        try {
          const catRes = await getAllCategories();
          cats = unwrapList(catRes.data);
        } catch (error) {
          console.error("Failed to load categories:", error);
        }

        let list = [];

        try {
          const response = await getDoctors();
          list = unwrapList(response.data);
        } catch (error) {
          console.error("Failed to load doctors:", error);
        }

        // Retry with category names if the initial request returns no doctors.
        if (!list.length && cats.length) {
          const names = cats
            .map((category) => category.name)
            .filter(Boolean)
            .join(",");

          if (names) {
            try {
              const response = await getDoctors(names);
              list = unwrapList(response.data);
            } catch (error) {
              console.error("Failed to load doctors by category:", error);
            }
          }
        }

        if (!cancelled) {
          setRawDoctors(list);
          setCategories(cats);

          setSpecialtyFilter((current) =>
            current && cats.some((category) => category.name === current)
              ? current
              : cats[0]?.name || ""
          );
        }
      } catch (error) {
        if (!cancelled && isNetworkError(error)) {
          setNetworkError(true);
        } else {
          console.error("Doctor list loading error:", error);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);


  const apiType = toApiType(consultationType);

  const doctorsList = useMemo(
    () => rawDoctors.map((d) => mapToDoctorCard(d, apiType)),
    [rawDoctors, apiType]
  );

  const visibleDoctors = useMemo(() => {
    const q = searchTerm.trim();
    return doctorsList.filter((card) => {
      const raw = card._raw;
      if (!doctorMatchesSpecialty(raw, specialtyFilter)) return false;
      return doctorMatchesSearch(raw, q);
    });
  }, [doctorsList, specialtyFilter, searchTerm]);

  const handleBook = (doctor) => {
    navigate("/consultations/schedule", {
      state: { doctor, consultationType: apiType },
    });
  };

  return (
    <div className="bg-background min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-col min-h-screen pb-16 lg:pb-0 flex-1">
        <main className="flex-1 max-w-7xl mx-auto w-full px-3 sm:px-6 py-4 sm:py-8">
          <header className="mb-6 space-y-4">
            <h1 className="text-xl sm:text-2xl font-bold text-on-primary-fixed-var lg:hidden">
              Doctor Consultation
            </h1>

            <div className="flex flex-col sm:flex-row lg:items-center gap-3 lg:gap-4">
              <div className="inline-flex self-start bg-surface-low rounded-full p-1 border border-surface-container shrink-0">
                {[
                  { label: "Video Consult", value: PAGE_CONSULTATION_TYPE.video },
                  { label: "In-Person", value: PAGE_CONSULTATION_TYPE.inPerson },
                ].map((tab) => (
                  <button
                    key={tab.value}
                    type="button"
                    onClick={() => setConsultationType(tab.value)}
                    className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold transition ${consultationType === tab.value
                        ? "bg-primary-fixed text-on-primary-fixed-var"
                        : "text-on-surface-variant hover:text-on-primary-fixed-var"
                      }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <h1 className="hidden lg:block flex-1 text-3xl font-bold text-on-primary-fixed-var text-center">
                Doctor Consultation
              </h1>

              <div className="relative w-full lg:w-80 shrink-0">
                <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant" />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search by name, specialty, or condition..."
                  className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-surface-container bg-surface-lowest text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                />
              </div>
            </div>
          </header>

          <div className="mb-6 -mx-3 sm:mx-0">
            <p className="text-sm font-medium text-on-primary-fixed-var mb-2 px-3 sm:px-0">
              Popular Specialties:
            </p>
            <div className="flex gap-2 overflow-x-auto px-3 sm:px-0 pb-1">
              {categories.slice(0, 8).map((cat) => {
                const selected = specialtyFilter === cat.name;
                return (
                  <button
                    key={cat.name}
                    type="button"
                    onClick={() => setSpecialtyFilter(cat.name)}
                    className={`shrink-0 whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-medium border transition ${selected
                        ? "bg-primary text-white border-primary"
                        : "bg-surface-lowest text-primary border-primary hover:bg-primary-fixed/40"
                      }`}
                  >
                    {cat.name}
                  </button>
                );
              })}
            </div>
          </div>

          {networkError ? (
            <OfflineState onRetry={() => window.location.reload()} />
          ) : loading ? (
            <LoadingState branded message="Loading doctors…" className="py-16" />
          ) : visibleDoctors.length === 0 ? (
            <EmptyState
              title="No doctors found yet."
              description={`No doctors are available for ${consultationType === PAGE_CONSULTATION_TYPE.video ? "video" : "in-person"} consultation right now. Try another specialty or consultation type.`}
            />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {visibleDoctors.map((doctor) => (
                <DoctorCard
                  key={doctor.id || doctor.name}
                  doctor={doctor}
                  consultationType={consultationType}
                  onBookConsult={handleBook}
                />
              ))}
            </div>
          )}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default DoctorListPage;
